import {Link} from 'react-router-dom';
import Header from '../../Header';
import Sidebar from '../../Sidebar';
import Footer from '../../Footer';
import { deleteBuild } from "../../../redux/actions/BuildActions";
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const Build = (props) => {
	let { id, version, os, created_at, file_type, file_path, signedUrl, envirionment, is_public
	} = props.build;//role,
	let appId = props.app.id;
	let _organizationId = props?.organizationId;
	const organization = useSelector((state)=>state.organizationDetails.organization)
    const organizationRoles = organization?.user_role;
	const organizationId = organization?.organization_id;
	const role = useSelector((state) => state.userLogin.userInfo.data.role);
	const dispatch = useDispatch();

	  const deletehandler = (id) => {
	    if (window.confirm("Are you sure want to delete build?")) {
	      dispatch(deleteBuild(id));
	    }
	  };

      const downloadBuild = () => {
        const link = document.createElement('a');
        link.href = file_path;
        link.download = `app-${version}`; 
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
	  };

	  const copyUrl = (e) => {
		e.preventDefault();
		navigator.clipboard.writeText(`itms-services://?action=download-manifest&url=${signedUrl}`).then(() => {
		  toast.success("Installation URL copied");
		}).catch(err => {
		  console.error("Failed to copy text: ", err);
		  toast.error("Failed to copy URL");
		});
	  };

	  // Shareable public install URL — only rendered for builds marked
	  // Public. Points at the /install landing page which iOS + Android
	  // both handle (itms-services for iOS, direct APK download for Android).
	  const copyShareUrl = (e) => {
		e.preventDefault();
		const shareUrl = `${window.location.origin}/install/${appId}/${id}`;
		navigator.clipboard.writeText(shareUrl).then(() => {
		  toast.success("Public install URL copied");
		}).catch(err => {
		  console.error("Failed to copy text: ", err);
		  toast.error("Failed to copy URL");
		});
	  };

	return(
		<>
		    <tr>
              {/* <td>{sort}</td> */}
              <td>{version}</td>
              <td>{ moment(created_at).format('MMM DD, YYYY, hh:mm A')}</td>
			  <td>{os}</td>
              <td>{file_type}</td>
			  <td>{envirionment}</td>
			  <td>
				{is_public ?
					<span title="Public — shareable install URL" style={{
						background: '#DCFCE7', color: '#166534', fontSize: 11,
						fontWeight: 700, padding: '2px 8px', borderRadius: 999,
						letterSpacing: '0.04em', textTransform: 'uppercase',
					}}>Public</span>
					:
					<span title="Private — org members only" style={{
						background: '#F1F5F9', color: '#475569', fontSize: 11,
						fontWeight: 700, padding: '2px 8px', borderRadius: 999,
						letterSpacing: '0.04em', textTransform: 'uppercase',
					}}>Private</span>
				}
			  </td>
			  <td className="build-download">
				<Link
	                to="#"
                    onClick={() => downloadBuild()}  
					style={{ "paddingRight": "10px" }}    
					title="Download Build"           
	            >
	              	<i className="fa fa-download"></i>
	            </Link>
                {os === 'iOS'?
				 <>
				   	<a
	                   href={`itms-services://?action=download-manifest&url=${signedUrl}`}
					   style={{ "paddingRight": "10px" }}
					   title="Install Build"
	                >
	                 	<i className="fa fa-apple"></i>
	                </a>

				    <Link
	                  to="#"
					  onClick={copyUrl}
					  style={{ paddingRight: "10px", cursor: "pointer" }}
					  title="Copy itms-services Install URL"
	                >
	                 	<i className="fa fa-clipboard"></i>
	                </Link>
				 </>
				: null}

				{is_public ?
				    <Link
	                  to="#"
					  onClick={copyShareUrl}
					  style={{ paddingRight: "10px", cursor: "pointer", color: '#D89100' }}
					  title="Copy Public Install Link (share with testers)"
	                >
	                 	<i className="fa fa-share-alt"></i>
	                </Link>
				: null}

                { role === 'Super_Admin' ? 
				    <Link
				      to={`/organization/${_organizationId}/app/${appId}/build/${id}/view`}	 
				      style={{ "paddingRight": "10px" }}  
				      title="View Build Details"                 
			        >
				      <i className="fa fa-eye"></i>
			        </Link>
			    : 
				    <Link
				       to={`/app/${appId}/build/${id}/view`}	 
				       style={{ "paddingRight": "10px" }}  
				       title="View Build Details"                 
			        >
				      <i className="fa fa-eye"></i>
			        </Link>
				}
	           </td>
            </tr>
		</>
		)
}

export default Build;